const ITEMS = [
    "Pisos y casas",
    "Alquiler y venta",
    "Toda España",
    "Mejores precios",
    "Trato directo",
    "Todo en persona",
];

const Row = ({ ariaHidden = false }) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-brand-navy/80 dark:text-brand-cream/80 sm:text-3xl">
                    {item}
                </span>
                <span className="h-2 w-2 rounded-full bg-brand-orange" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        className="overflow-hidden border-y border-brand-navy/10 bg-brand-cream py-6 dark:border-white/10 dark:bg-brand-night"
        data-testid="marquee"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row ariaHidden />
        </div>
    </div>
);
